import "../utils/constants"
import '../sass/styles.scss';
import '../../src/utils/prototypes';
import { useEffect, useRef, useState } from "react";
import { Dropdown, DropdownToggle, Form } from "react-bootstrap";
import i18n from "../i18n/i18n";
import { useDoctorSearchList } from "../api/CalendarAPI";
import { HighlightedText } from "../screen/patient/FindAppointment";
import { AssociationTypes, DevPath, DoctorTitle, GetCurrentUserType, GetLoggedUserUUID, Images, landingLocalStorageKey } from "../utils/constants";
import { useAutoCompleteLocation } from "../hooks/LocationAutoComplete";
import { Icon } from "@iconify/react";
import clsx from "clsx";
import PlacesSearchBar from "../utils/PlacesSearchBar";
import LocationProvider from "../utils/locationContext/LocationProvider";
import { useTimeHook } from '../hooks/useTimeHook';
import { createRoot } from "react-dom/client";

const LandingSearch = () => {
    const [showList, setShowList] = useState(false)
    const [search, setSearch] = useState({})
    const searchRef = useRef()
    const btnRef = useRef()
    const { location, reset, currentLocation } = useAutoCompleteLocation({ aroundMe: true })
    const [searchRes, setSearchRes] = useState({})
    const [error, setError] = useState(false)
    const timeOut = useTimeHook({ duration: 400 })
    const debouncedcall = (searchKey) => {
        timeOut.delay(
            () => {
                searchListAPI.get(`?search=${searchKey?.ignoreAccent?.()}`)
            }
        )
    }
    const searchListAPI = useDoctorSearchList({ getInitial: false, resBody: {} })
    const patientEndPoint = `${DevPath}`
    const patAppointmentFlowPath = GetLoggedUserUUID() ? `${patientEndPoint}/${GetCurrentUserType()}/${GetLoggedUserUUID()}` : patientEndPoint

    const AppNav = {
        patientAppointment: `${patAppointmentFlowPath}/create-appointment`,
        medicalInfo: `${patAppointmentFlowPath}/profile/medicalcenter-profile`,
        doctorInfo: `${patAppointmentFlowPath}/profile/doctor-profile`,
    }


    useEffect(() => {
        if (search?.text?.ignoreAccent?.()?.toLowerCase?.() === searchListAPI.data?.search?.ignoreAccent?.()?.toLowerCase?.()) {
            const tags = searchListAPI.data?.speciality_tag?.reduce((pre, curr) => {
                curr?.tag?.forEach?.((data) => {
                    if (pre?.find?.(obj => obj?.name.toLowerCase() == data?.toLowerCase?.())) {
                        return pre
                    }
                    pre.push(
                        {
                            id: curr?.id,
                            name: data,
                            speciality: { id: curr?.id, specialite_nom: curr?.specialite_nom }
                        }
                    )
                })
                return pre
            }, [])
            if (tags) {
                searchListAPI.data.tags = tags
            }

            setSearchRes(searchListAPI.data)
        }
    }, [searchListAPI.data])
    const [searchFocus, setSearchFocus] = useState(false)

    const GoToPage = (state) => {
        const navUrl = new URL(`${window.origin}${AppNav.patientAppointment}`)
        navUrl.searchParams.set('state', JSON.stringify(
            { ...state }
        ))
        window.open(navUrl, "_self")
    }

    const onSubmit = () => {
        if (!search?.text?.trim()) {
            setError(true)
            return
        }
        const segments = window.location.href.split('/');
        const uuid = segments[segments.length - 1];

        const resetUserAppointment = () => { // Incase user is already logged in
            const ReduxKey = `persist:session_${uuid}`
            const UserData = JSON.parse(localStorage.getItem(ReduxKey))
            if (UserData && UserData.patientAppointment) {
                UserData.patientAppointment = JSON.stringify({
                    "doctor": null,
                    "step": 0
                })
                localStorage.setItem(ReduxKey, JSON.stringify(UserData))
            }
        }

        if (localStorage.getItem('persist:session_Guest') != null) {
            localStorage.removeItem('persist:session_Guest') // Guest user case
            if (GetLoggedUserUUID() != null && uuid == GetLoggedUserUUID()) { // Incase user is already logged in and Guest redux store
                resetUserAppointment()
            }
        } else {
            resetUserAppointment() // Incase No Guest Redux and user is already logged in
        }
        const docSearch = searchRes?.doctors?.[0]
        const fullname = (docSearch?.first_name?.toLowerCase?.().trim() || '') + ' ' + (docSearch?.last_name?.toLowerCase?.().trim() || '')
        const isDoctorSearched = docSearch?.first_name.toLowerCase().trim().includes(search?.text?.toLowerCase().trim())
            || docSearch?.last_name.toLowerCase().trim().includes(search?.text?.toLowerCase().trim()) || fullname?.includes(search?.text?.toLowerCase().trim())

        const firstItem = searchRes?.speciality?.[0]?.specialite_nom ? 'speciality' :
            searchRes?.tags?.[0]?.name ? 'tag' :
                searchRes?.categories?.[0]?.category_nom ? 'category' :
                    (isDoctorSearched && fullname) ? 'doctor' :
                        (searchRes?.locations?.[0]?.location_name) ? 'location' : null

        const navUrl = new URL(`${window.origin}${AppNav.patientAppointment}`)
        const type = search?.type || firstItem
        switch (type) {
            case 'speciality':
                const speciality = searchRes?.speciality?.[0]
                localStorage.setItem(landingLocalStorageKey, JSON.stringify({
                    specialisation: search?.value || {
                        id: speciality?.id,
                        nom: speciality?.specialite_nom,
                        parent_speciality_id: speciality?.parent_speciality_id
                    },
                    isSpeciality: true,
                    step: 1,
                    location: location,
                    currentLocation: currentLocation,
                }));
                window.open(navUrl, "_self")
                break;
            case 'category':
                const category = searchRes?.categories?.[0]
                localStorage.setItem(landingLocalStorageKey, JSON.stringify({
                    specialisation: search?.value?.specialisation || {
                        id: category?.specialite_id, nom: category?.specialite_nom
                    },
                    category: search?.value?.category || { id: category?.id, nom: category?.category_nom },
                    isCategory: true,
                    step: 1,
                    location: location,
                    currentLocation: currentLocation,
                }));
                window.open(navUrl, "_self")
                break;
            case 'tag':
                const tag = searchRes?.tags?.[0]
                localStorage.setItem(landingLocalStorageKey, JSON.stringify({
                    specialisation: search?.value || {
                        id: tag?.speciality?.id,
                        nom: tag?.speciality?.specialite_nom,
                        parent_speciality_id: tag?.speciality?.parent_speciality_id
                    },
                    isSpeciality: true,
                    step: 1,
                    location: location,
                    currentLocation: currentLocation,
                }));
                window.open(navUrl, "_self")
                break;
            case 'doctor':
                const docUrl = new URL(`${window.origin}${AppNav.doctorInfo}`)
                const doc = searchRes?.doctors?.[0]
                const docSend = {
                    id: doc?.id,
                    speciality: { specialisation_id: doc?.speciality?.specialisation_id }
                }
                localStorage.setItem(landingLocalStorageKey, JSON.stringify({ ...docSend, isDoctor: true }));
                window.open(docUrl, "_self")
                break;
            case 'location':
                const locUrl = new URL(`${window.origin}${AppNav.medicalInfo}`)
                const loc = searchRes?.locations?.[0]
                const send = {
                    latitude: loc?.latitude,
                    location_id: loc?.location_id,
                    longitude: loc?.longitude
                }
                localStorage.setItem(landingLocalStorageKey, JSON.stringify({ ...send, isDoctor: false }));
                window.open(locUrl, "_self")
                break;
            default:
                break;
        }
    }


    return (
        <div className={clsx({
            'hero-search': true,
            'error': error,
            'landing': true
        })}>
            <Form.Group className="form-group search-box d-flex">
                <Dropdown
                    show={true}
                    onToggle={(nextShow) => {
                        setShowList(nextShow)
                    }}>
                    <DropdownToggle>
                        <Form.Control className="form-control" type="text"
                            placeholder={i18n.t('research_placeholder')}
                            value={search?.text?.capitalizeEachWord?.()}
                            ref={searchRef}
                            onFocus={() => {
                                setSearchFocus(true)
                            }}
                            onBlur={() => {
                                setSearchFocus(false)
                                setShowList(true)
                            }}
                            onChange={(e) => {
                                error && setError(false)
                                const searchText = e.target.value
                                setSearch({ text: searchText, click: false })
                                setShowList(true)
                                if (searchText.trim().length > 0) {
                                    if (searchRef.current.className.includes('error')) {
                                        searchRef.current.className = searchRef.current.className.replace('error', '')
                                    }
                                    debouncedcall(searchText)
                                }
                            }}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                    searchRef.current?.blur?.()
                                    setShowList(false)
                                } else if (event.key === ' ') {
                                    setTimeout(() => {
                                        setShowList(true)
                                    }, 500)
                                }
                            }}
                        />
                        <Icon icon="iconoir:search" />
                    </DropdownToggle>
                    {
                        ((showList && search?.text?.length > 0) || (searchFocus && search?.text?.length > 0)) && Object.values(searchRes || {}).some(vals => typeof vals != 'string' && vals?.length > 0) &&
                        <Dropdown.Menu
                            style={{ width: '600px' }}
                            show={true}
                            className={clsx({ 'doctor-list': true, 'show': true })}
                        >
                            <>
                                {Array.isArray(searchRes?.speciality) && searchRes?.speciality?.map((speciality, index) => {
                                    const specialite_nom = speciality?.specialite_nom
                                    return (
                                        specialite_nom && <Dropdown.Item
                                            onClick={() => {
                                                setSearch({
                                                    type: 'speciality', value: {
                                                        id: speciality?.id,
                                                        nom: speciality?.specialite_nom,
                                                        parent_speciality_id: speciality?.parent_speciality_id
                                                    },
                                                    text: specialite_nom,
                                                    special: speciality,
                                                    click: true
                                                })
                                                searchListAPI.get(`?search=${specialite_nom}`)
                                            }}
                                            key={index}
                                            className="doctor-list-item">
                                            <div className="doc-detail" style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                flex: 1
                                            }}>
                                                <div className="doc-top">
                                                    <HighlightedText actualValue={specialite_nom?.capitalizeEachWord()} searchText={search?.text.trim()} />
                                                </div>
                                            </div>
                                        </Dropdown.Item>
                                    )
                                })}
                                {Array.isArray(searchRes?.tags) && searchRes?.tags?.map((tag, index) => {
                                    return (
                                        <Dropdown.Item
                                            onClick={() => {
                                                setSearch({
                                                    type: 'tag', value: {
                                                        id: tag?.speciality?.id,
                                                        nom: tag?.speciality?.specialite_nom,
                                                        parent_speciality_id: tag?.speciality?.parent_speciality_id
                                                    },
                                                    text: tag?.name,
                                                    tag: 1,
                                                    click: true,
                                                    special: tag?.speciality
                                                })
                                                searchListAPI.get(`?search=${tag?.name}`)
                                            }}
                                            key={index}
                                            className="doctor-list-item">
                                            <div className="doc-detail" style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                flex: 1
                                            }}>
                                                <div className="doc-top">
                                                    <HighlightedText actualValue={tag?.name?.capitalizeEachWord?.()} searchText={search?.text?.trim()} />
                                                </div>
                                            </div>
                                        </Dropdown.Item>
                                    )
                                })}

                                {Array.isArray(searchRes?.categories) && searchRes?.categories?.map((category, index) => {
                                    return (
                                        <Dropdown.Item
                                            onClick={() => {
                                                setSearch({
                                                    type: 'category', value: {
                                                        specialisation: { id: category?.specialite_id, nom: category?.specialite_nom },
                                                        category: { id: category?.id, nom: category?.category_nom }
                                                    }, text: category?.category_nom, click: true
                                                })
                                                searchListAPI.get(`?search=${category?.category_nom}`)
                                            }}
                                            key={index}
                                            className="doctor-list-item">
                                            <div className="doc-detail" style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                flex: 1
                                            }}>
                                                <div className="doc-top">
                                                    <HighlightedText actualValue={category?.category_nom?.capitalizeEachWord()} searchText={search?.text?.trim()} />
                                                </div>
                                            </div>
                                        </Dropdown.Item>
                                    )
                                })}

                                <div style={{ width: '100%', height: 1, backgroundColor: '#CCD3D8' }} />
                                {Array.isArray(searchRes?.doctors) && searchRes?.doctors?.map((doc, index) => {
                                    const { first_name, last_name, ville: city, speciality, profile_photo, doctor_title } = doc
                                    const fullname = first_name + ' ' + last_name
                                    return (
                                        <Dropdown.Item key={index} className="doctor-list-item"
                                            onClick={() => {
                                                const navUrl = new URL(`${window.origin}${AppNav.doctorInfo}`)
                                                const send = {
                                                    id: doc?.id,
                                                    speciality: { specialisation_id: doc?.speciality?.specialisation_id }
                                                }
                                                localStorage.setItem(landingLocalStorageKey, JSON.stringify({ ...send, isDoctor: true }))
                                                window.open(navUrl, "_self")
                                            }}>
                                            <div className="doc-img">
                                                {<img src={profile_photo || Images.defaultDoctor} alt="Doctor" />}
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'start' }} className="doc-detail">
                                                <div style={{ display: 'flex', alignItems: 'center' }} className="doc-top">
                                                    <HighlightedText actualValue={(doctor_title ? DoctorTitle?.[doctor_title] + ' ' : '') + fullname?.capitalizeEachWord()} searchText={search?.text?.trim?.()} />
                                                    {speciality && <div className="doc-desc">{speciality?.specialisation?.capitalizeEachWord()}</div>}
                                                </div>
                                                <div className="doc-addr">
                                                    {city && city?.capitalizeEachWord()}
                                                </div>
                                            </div>
                                        </Dropdown.Item>
                                    )
                                })}
                                {Array.isArray(searchRes?.locations) && searchRes?.locations?.map((location, index) => {
                                    const { address, city, organization_type, logo, location_name } = location
                                    return (
                                        <Dropdown.Item key={index} className="doctor-list-item"
                                            onClick={() => {
                                                const navUrl = new URL(`${window.origin}${AppNav.medicalInfo}`)
                                                const send = {
                                                    latitude: location?.latitude,
                                                    location_id: location?.location_id,
                                                    longitude: location?.longitude
                                                }
                                                localStorage.setItem(landingLocalStorageKey, JSON.stringify({ ...send, isDoctor: false }))
                                                window.open(navUrl, "_self")
                                            }}>
                                            <div className="doc-img">
                                                {<img src={logo || Images.defaultDoctor} alt="Doctor" />}
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'start' }} className="doc-detail">
                                                <div style={{ display: 'flex', alignItems: 'center' }} className="doc-top">
                                                    <HighlightedText actualValue={location_name?.capitalizeEachWord()} searchText={search?.text?.trim?.()} />
                                                </div>
                                                <div className="doc-addr">
                                                    {AssociationTypes.find(assoc => assoc.id == organization_type)?.text}
                                                    {city && <br />}
                                                    {city && city?.capitalizeEachWord()}
                                                </div>
                                            </div>
                                        </Dropdown.Item>
                                    )
                                })}
                            </>
                        </Dropdown.Menu>
                    }


                </Dropdown>
            </Form.Group>
            <div className="hsearch-btm">
                <Form.Group className="search-box">
                    <PlacesSearchBar placeholder={i18n.t('where')} onChange={(event) => {
                        error && setError(false)
                        if (event?.target?.value == '') {
                            reset()
                        }
                    }} />
                    <Icon icon="ic:round-gps-fixed" />
                </Form.Group>
                <button ref={btnRef} onClick={onSubmit} type="button" className="btn" title={i18n.t("research")} children={i18n.t("research")} />
            </div>

        </div>
    )
}
const container = document.getElementById("landing-user-search")
const root = createRoot(container);
root.render(
    <LocationProvider>
        <LandingSearch />
    </LocationProvider>
);

export default LandingSearch